import React, { useContext, useCallback } from 'react';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import CreateVideoStudioModalState from './CreateVideoStudioModal/createVideoStudioModalContext/createVideoStudioModalState/CreateVideoStudioModalState';
import EditVideoStudioModalState from './EditVideoStudioModal/editVideoStudioModalContext/editVideoStudioModalState/EditVideoStudioModalState';
import CreateVideoStudioModal from './CreateVideoStudioModal/CreateVideoStudioModal';
import EditVideoStudioModal from './EditVideoStudioModal/EditVideoStudioModal';
import { VideoStudiosContext, IVideoStudiosContext } from '../../videoStudiosState/videoStudiosContext';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { deleteSelectedItem, changeTypeOfModalWindow, typeOfModalWindow } =
		useContext<IVideoStudiosContext>(VideoStudiosContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteVideoStudio"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteVideoStudioSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingVideoStudio"
			/>
			<CreateVideoStudioModalState>
				<CreateVideoStudioModal isVisible={typeOfModalWindow === 'createStudio'} />
			</CreateVideoStudioModalState>
			<EditVideoStudioModalState>
				<EditVideoStudioModal isVisible={typeOfModalWindow === 'editStudio'} />
			</EditVideoStudioModalState>
		</div>
	);
};

export default ModalWindows;
